import React from 'react';
import Modal from 'Utils/Modal';
import * as actions from 'Actions';
import { connect } from 'react-redux';
import service from 'Api/service';
import { saveError } from 'Api';
import { RemoveCircle } from 'Utils/SvgIcons';
import Endpoints from 'Api/endpoints';

class MaintainMultipleModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: [],
      serialNumber: '',
      quantity: '',
    };
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handleSerialNumberReset = () => {
    this.setState({
      serialNumber: '',
      quantity: '',
    });
  };

  performSearch = (event) => {
    event.preventDefault();
    const { product, setErrors } = this.props;
    const { serialNumber, quantity } = this.state;

    if (quantity === '' || +quantity <= 0) {
      setErrors('Invalid quantity');
      return;
    }

    const component = this;
    Endpoints.serializedProducts
      .showBySerialNumber(product, serialNumber)
      .then((response) => {
        const { selected } = component.state;
        const { serializedProduct } = response.data;
        if (serializedProduct.quantity < +quantity) {
          setErrors('Cannot put items into maintenance more than we have');
        } else {
          const foundIndex = selected.findIndex(
            (sp) => sp.serialNumber === serializedProduct.serialNumber
          );
          if (foundIndex === -1) {
            component.setState({
              selected: [
                ...selected,
                { ...serializedProduct, maintenanceQuantity: quantity },
              ],
              serialNumber: '',
              quantity: '',
            });
          } else {
            setErrors('Serial number already added.');
            component.setState({
              serialNumber: '',
              quantity: '',
            });
          }
        }
      })
      .catch((error) => {
        setErrors('Unknown/invalid token provided.');
        console.log(error);
      });
  };

  handleSubmit = () => {
    const { selected } = this.state;

    // Validation
    if (selected.length === 0) {
      this.props.setErrorMessage({
        field: 'selected',
        text: 'You need to select at least one serialized item.',
      });
    } else {
      const { product } = this.props;
      const component = this;
      const { selected } = component.state;
      const selectedSp = selected[0];
      service
        .post(
          import.meta.env.VITE_API_DOMAIN +
            `/api/products/${product.id}/serialized_products/${selectedSp.id}/maintain_multiple`,
          {
            quantity: selectedSp.maintenanceQuantity,
          }
        )
        .then((response) => {
          component.props.openSuccessSnackBar(response.data.message);
          component.props.toggle();
          if (component.props.onRefresh) {
            component.props.onRefresh();
          }
        })
        .catch((error) => {
          console.log(error);
          saveError(error);
        });
    }
  };

  removeItem = (serialNumber) => {
    const newSelected = this.state.selected.filter(
      (s) => s.serialNumber !== serialNumber
    );
    this.setState({
      selected: newSelected,
    });
  };

  render() {
    const { product, open, toggle } = this.props;
    const { serialNumber, quantity, selected } = this.state;

    return (
      <Modal
        open={open}
        toggle={toggle}
        large={true}
        className='serializedModal'
        title='Put Serialized Items in Maintenance'
        actions={[
          <a className='btn' onClick={this.handleSubmit}>
            Submit And Update Rental Inventory
          </a>,
          <a className='btn cancel' onClick={toggle}>
            Cancel
          </a>,
        ]}
      >
        <div>
          <h2>{product.name}</h2>
          <form className='fullForm' onSubmit={this.performSearch}>
            <input
              type='text'
              name='serialNumber'
              className='barcode'
              onChange={this.handleChange}
              value={serialNumber}
            />
            <input
              type='text'
              name='quantity'
              onChange={this.handleChange}
              value={quantity}
            />
            <input
              type='submit'
              value='Add Item to Maintenance List'
              className='btn'
            />
            <button
              className='btn cancel'
              onClick={this.handleSerialNumberReset}
            >
              Cancel
            </button>
          </form>
          <section>
            <h4>Total</h4>
            <strong>{selected.length}</strong>
            <table className='grid'>
              <thead>
                <tr>
                  <th>Serial No</th>
                  <th>Quantity</th>
                  <th className='actionSm' />
                </tr>
              </thead>
              <tbody>
                {selected.map((s, index) => (
                  <tr key={index}>
                    <td>{s.serialNumber}</td>
                    <td>{s.maintenanceQuantity}</td>
                    <td>
                      <a
                        className='btnLink remove'
                        onClick={() => this.removeItem(s.serialNumber)}
                      >
                        <RemoveCircle />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const { rental, loading } = state.rental;
  const { errors } = state.dashboard;
  return { rental, loading, errors };
};

export default connect(mapStateToProps, actions)(MaintainMultipleModal);
